import React, { useRef } from 'react';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Title, Code, Actions, API, Utility, Button, Messages, Control } from 'helpers/PrintImports';
import { Stock } from "models/StockModel";
import { User } from 'models/UserModel';
import { Doctor } from 'models/DoctorModel';
import { Client } from 'models/ClientModel';
import { Class } from 'constants/codes';
import SignaturePad from "components/common/SignManager";

const StockPrint: React.FC = () => {
  const width = { product: 80, price: 12, qty: 20, discount: 12, gst: 12, Amount: 12 }
  const [formId, formName] = [Code.Form.Id.STOCK, Code.Form.Name.STOCK];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef } = usePrintContext();
  const [stockData, setStockData] = useState<Stock>({});
  const [userData, setUserData] = useState<User | null>(null);
  const [receiverName, setReceiverName] = useState<string>('');
  const [receiverPhone, setReceiverPhone] = useState<string>('');
  const [signData, setSignData] = useState<string>('');

  const Privilege = Hooks.Privilege.List(formId);
  const printRef = useRef<HTMLDivElement>(null);
  Hooks.Privilege.HasPrint(Privilege);
  const companyId = Utility.Storage.CompanyId();
  const locationId = Utility.Storage.LocationId();

  const companyName = Utility.Storage.CompanyName();

  useEffect(() => {
    API.Data.GetByKeyId<Stock>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setStockData((prevData) => ({
        ...prevData,
        ...formData,
      }));
      setUserData(await API.Data.GetUser(data.user_id));
    }})
    setLoading(false);
  }, []); 

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Messages.Toast Messages={message} Error={error} />
        <Button.Print keyId={keyId} formName={formName} Privilege={Privilege} signData={signData} fileName={stockData.stock_number} docType={Code.Option.DocumentType.STOCK} signRequire={true} printRef={printRef} setMessage={setMessage} setError={setError} />
        <Control.Print.Data ref={printRef}>
            <Control.Flex>
              <Control.Column size={[0,60,0,0]}>
                <Control.Box>
                  <Field.CompanyHead companyId={companyId} locationId={locationId} />
                </Control.Box>
              </Control.Column>
              <Control.Column size={[0,40,0,0]} align={Code.Align.RIGHT}>
                <Control.Box>
                  <Field.SubHead title={Utility.Get.FormName(stockData.type_id)} />
                  <Control.Form.Barcode value={stockData.stock_number!} />       
                  <Field.Value title={Title.RefSno} value={stockData.stock_number} />
                  <Field.Value title={Title.Date} value={Utility.Format.DateOnly(stockData.stock_date)} />
                  <Field.Value title={Title.Dispenser} value={Utility.Get.FullName(userData,Code.Form.Name.USER)} />
                </Control.Box>
              </Control.Column>
            </Control.Flex>
            <Control.Print.Table>
              <Control.Print.Title>
                <Control.Grid.Items values={[
                  [Title.Desc, width.product], 
                  [Title.Qty, width.qty, Code.Align.CENTER],
                  // [Title.Price, width.price, Code.Align.RIGHT], 
                  //[Title.Disc, width.discount, Code.Align.RIGHT],
                  // [Title.GST, width.gst, Code.Align.RIGHT],
                  // [Title.Amount, width.Amount, Code.Align.RIGHT]
                ]} upper={true} />
              </Control.Print.Title>
              <Control.Print.List>
                {stockData.items?.map((item, index) => (
                  <Control.Print.Index key={index} index={index}>
                    <Control.Print.Item>
                      <Control.Print.Product product={item.product_name} sku={item.item_skucode} comment={item.item_comment} size={[width.product]} />
                      <Control.Print.Text value={item.item_quantity} size={[width.qty]} align={Code.Align.CENTER} />
                      {/* <Control.Print.Number value={item.item_price} size={[width.price]}  />
                      <Control.Print.Number value={item.item_discount_amount} size={[width.discount]} />
                      <Control.Print.Number value={item.item_tax1_amount} size={[width.gst]} />
                      <Control.Print.Number value={item.item_net_amount} size={[width.Amount]}  />  */}
                    </Control.Print.Item>
                  </Control.Print.Index>
                ))}
              </Control.Print.List>
            </Control.Print.Table>
            <Control.Flex className={Class.ptop3}>
              <Control.Column size={[0,70,0,0]}>
                <Control.Box>
                  <Control.Print.Term value={""} />
                </Control.Box>
              </Control.Column>
              <Control.Column size={[0,5,0,0]}><></></Control.Column>
              <Control.Column size={[0,25,0,0]} align={Code.Align.RIGHT}>
                <Control.Box>
                  <Field.Total title={Title.Gross} value={stockData.stock_gross_amount} />
                  <Field.Total title={Title.Discount} value={stockData.stock_discount_amount} />
                  <Field.Total title={Title.GST} value={stockData.stock_tax_amount} />
                  <Field.Total title={Title.Payable} value={stockData.stock_payable_amount} borderBottom={true} />
                </Control.Box>
              </Control.Column>
            </Control.Flex>

            <SignaturePad signData={signData} setSignData={setSignData} receiverName={receiverName} setReceiverName={setReceiverName} receiverPhone={receiverPhone} setReceiverPhone={setReceiverPhone} />
            
            <Field.PrintedOn fixed={false} />
        </Control.Print.Data>    
      </>)}
      {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Print />
    </Control.Print.Frame>
  );
};

export default StockPrint;